import { takeLatest, put } from 'redux-saga/effects';
import { submitPreScreenToUnderwrite, setChannelWorkflowLoadingOverlayState, appNotify } from 'store/actions';
import { putWithTokenV2 } from 'api/network';

export function* submitPreScreenToUnderwriteSaga() {
  yield takeLatest(submitPreScreenToUnderwrite, function* ({ payload }) {
    const { txnOppIds } = payload;
    try {
      yield put(setChannelWorkflowLoadingOverlayState({ isLoading: true, message: 'Submitting to underwriting...' }));
      yield putWithTokenV2(`/api/underwrite/workflow/tasks/submitToUnderwrite`, txnOppIds);
      yield put(setChannelWorkflowLoadingOverlayState({ isLoading: false, message: null }));
      yield put(appNotify('Successfully submitted to underwriting', 'success'));
    }
    catch (error) {
      yield put(appNotify(error.message, 'error'));
      yield put(setChannelWorkflowLoadingOverlayState({ isLoading: false, message: null }));
    }
  });
}